<template>
    <div style="position: relative;" :class="!endAnimate ? 'on_bg_cl' : ''">
        <div v-if="!endAnimate" style="display: flex; position: relative; justify-content: center; height: 100%; align-items: center;">
            <div style="width: 200px; height: 200px; position: relative; display: flex; justify-content: center; align-items: center;">
                <div v-if="!isLanding" :class="showContents ? 'show_contents_text' : 'un_show_contents_text'" style="position: absolute; top: -230px; font-size: 32px; font-weight: 700; color: #fff; line-height: 46px; width: 390px; text-align: center;">포지션 찾기 <span class="special_color">PRO</span></div>
                <div v-else :class="showContents ? 'show_contents_text' : 'un_show_contents_text'" style="position: absolute; top: -230px; font-size: 32px; font-weight: 700; color: #fff; line-height: 46px; width: 390px; text-align: center;">사커하우 포지션 찾기</div>
                <img :src="stepStatus === 5 ? require('@/assets/img/ground_2_pro.png') : require('@/assets/img/animate_ground_pro.png')" :class="[{ step1: stepStatus === 1 }, { step2: stepStatus === 2 }, { step3: stepStatus === 3 }, { step4: stepStatus === 4 }, { step5: stepStatus === 5 }, { show_contents: showContents }]">
                <img :src="require('@/assets/img/soccer_ball_pro.png')" :class="[{ step1_ball: stepStatus === 1 }, { step2_ball: stepStatus === 2 }, { step3_ball: stepStatus === 3 }, { step4_ball: stepStatus === 4 }, { step_end_ball: stepStatus === 5 }]" style="position: absolute; " alt="">
                <div class="step1_circle" :class="[{ step1_ani1: stepStatus === 1 }, { step2_ani1: stepStatus === 2 }, { step3_ani1: stepStatus === 3 }, { step4_ani1: stepStatus === 4 }, { step_end1: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani2: stepStatus === 1 }, { step2_ani2: stepStatus === 2 }, { step3_ani2: stepStatus === 3 }, { step4_ani2: stepStatus === 4 }, { step_end2: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani3: stepStatus === 1 }, { step2_ani3: stepStatus === 2 }, { step3_ani3: stepStatus === 3 }, { step4_ani3: stepStatus === 4 }, { step_end3: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani4: stepStatus === 1 }, { step2_ani4: stepStatus === 2 }, { step3_ani4: stepStatus === 3 }, { step4_ani4: stepStatus === 4 }, { step_end4: stepStatus === 5 }]" style=""></div>
                <div class="step1_circle" :class="[{ step1_ani5: stepStatus === 1 }, { step2_ani5: stepStatus === 2 }, { step3_ani5: stepStatus === 3 }, { step4_ani5: stepStatus === 4 }, { step_end5: stepStatus === 5 }]" style=""></div>
                <!-- <div :class="showContents ? 'show_contents_text' : 'un_show_contents_text'" style="position: absolute; bottom: 0; font-size: 14px;">
                    <div style="margin-bottom: 25px; color: #fff;">현재 나의 축구 포지션: {{ originallyPosition === '' ? '없음' : originallyPosition }}</div>
                    <div style="color: #fff;">{{ originallyPosition === '' ? '아직 포지션을 찾지 않았어요' : '새로운 포지션을 찾아보세요' }}</div>
                </div> -->
                <div @click="startPositionPro" :class="showContents ? 'show_contents_text' : 'un_show_contents_text'" style="font-weight: 500; font-size: 14px; color:#345AA1; background-color: #f5f5f5; position: absolute; bottom: -150px; width: 330px; height: 47px; border-radius: 22.5px; line-height: 47px; text-align: center;">시작</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyPositionPro',
    props: {
        originallyPosition: {
            type: String,
            default: '',
        },
        is_free: {
            type: Boolean,
            default: false,
        },
        isLanding: {
            type: Boolean,
            default: false
        }
    },
    created() {
        setTimeout(() => {
            this.stepStatus = 2
        }, 1000);

        setTimeout(() => {
            this.stepStatus = 3
        }, 1900);

        setTimeout(() => {
            this.stepStatus = 4
        }, 2800);

        setTimeout(() => {
            this.stepStatus = 5
        }, 3700);


        setTimeout(() => {
            this.showContents = true
        }, 4600);
    },
    data() {
        return {
            endAnimate: false,
            showPosition: false,
            stepStatus: 1,
            showContents: false,
        }
    },
    methods: {
        startPositionPro() {
            this.$GlobalStore.closeLastModal();
            this.$GlobalStore.addModal('MyPositionProMain', {is_free: this.is_free, isLanding: this.isLanding})
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.on_bg_cl {
    background: linear-gradient(180deg, #1370AF 0%, #210F03 31.66%);
}

.step1 {
    width: 325px;
    transform: scale(3.5);
    transition: transform 0.5s
}

.step2 {
    width: 325px;
    transform: scale(2.1);
    transition: transform 0.5s
}

.step3 {
    width: 325px;
    transform: scale(1.7);
    transition: transform 0.5s
}

.step4 {
    width: 325px;
    transform: scale(1);
    transition: transform 0.5s
}

.step5 {
    transform: rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents {
    transform: translateY(-112px) rotate(90deg);
    width: 203px;
    transition: transform 1s, width 1s, top 1s;
}

.show_contents_text {
    opacity: 1;
    transition: opacity .5s
}

.un_show_contents_text {
    opacity: 0;
    pointer-events: none;
}

.step1_ani1 {
    right: 17%;
    top: 42%;
}

.step1_ani2 {
    right: 53%;
    top: -53%;
}

.step1_ani3 {
    right: 117%;
    top: 220px;
}

.step1_ani4 {
    right: -56%;
    top: 186%;
}

.step1_ani5 {
    right: 33%;
    top: 223%;
}

.step1_ball {
    width: 28px;
    top: 30%;
    right: 39%;
}

.step2_ani1 {
    top: 20%;
    right: 2%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani3 {
    top: 50%;
    right: 95%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani4 {
    top: 91%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ani5 {
    top: 143%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step2_ball {
    width: 28px;
    top: -3%;
    right: 72%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.6);
}

.step3_ani1 {
    top: -44%;
    right: -17%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani2 {
    top: -22%;
    right: 63%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani3 {
    top: 22%;
    right: 106%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani4 {
    top: 27%;
    right: -38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ani5 {
    top: 96%;
    right: 35%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step3_ball {
    width: 28px;
    top: -47%;
    right: 5%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.5);
}

.step4_ani1 {
    top: -13%;
    right: 9%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end1 {
    top: -13%;
    right: 9%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani2 {
    top: -4%;
    right: 38%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end2 {
    top: -4%;
    right: 38%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani3 {
    top: 11%;
    right: 76%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end3 {
    top: 11%;
    right: 76%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani4 {
    top: 22%;
    right: -20%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end4 {
    top: 22%;
    right: -20%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ani5 {
    top: 75%;
    right: 30%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end5 {
    top: 75%;
    right: 30%;
    opacity: 0;
    transition: top 0.5s, right 0.5s, transform 0.5s, opacity 0.5s;
    transform: scale(0.3);
}

.step4_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    transition: top 0.5s, right 0.5s, transform 0.5s;
    transform: scale(0.3);
}

.step_end_ball {
    width: 28px;
    top: -83%;
    right: 46%;
    opacity: 0;
    transition: top 1s, right 1s, transform 1s, opacity 1s;
    transform: scale(0.3);
}


.step1_circle {
    height: 60px;
    width: 60px;
    background-color: #466091;
    border-radius: 50%;
    box-shadow: 0px 4px 4px 0px #00000040;
    position: absolute;
}

.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
}

.special_color {
    background: conic-gradient(from 150.33deg at 80.96% 54.35%, #B8C9D3 -28.12deg, #FBFBFD 26.25deg, #C8D4DA 88.12deg, #FFFFFF 156.58deg, #AEC0CE 191.74deg, #E3E9EE 237.13deg, #FAFBFC 255.19deg, #D6DFE6 310.11deg, #B8C9D3 331.88deg, #FBFBFD 386.25deg);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-weight: 900;
}
</style>